<template>
    <div class="section-regions" :class="{'is-all-list': isAllRegions}">
        <div class="section-regions__title">Ваши продажи:</div>
        <div class="section-regions__content">
            <div class="section-regions__scroll" v-bar="{
                useScrollbarPseudo: true,
                preventParentScroll: true,
                unselectableBody: false
            }">
                <div>
                    <div class="section-regions__item" v-for="region in list" :key="region.id">
                        <block-region
                            :good-id="region.goodId"
                            :good-title="goodById(region.goodId).title"
                            :region-title="region.title"
                            :progress="region.progress"
                            :disabled="region.levelIndex === 8"
                            @upgrade="onUpgrade(region)"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="section-regions__actions" v-if="!isAllRegions">
            <a class="section-regions__actions-btn ui-btn" :class="{disabled: balance === 0}" @click="onAdd">
                <icon-plus class="section-regions__actions-btn-icon" />
                Добавить товар
            </a>
        </div>

        <template v-if="fakeUpdates && upgradeRegion">
            <div class="section-regions__upgrade section-regions__upgrade--fake">
                <section-upgrade
                    :region-id="upgradeRegion.id"
                    @close="onCloseUpgrade"
                />
            </div>
        </template>

        <transition name="slide-down">
            <div class="section-regions__upgrade" v-if="upgradeRegion">
                <section-upgrade
                    :region-id="upgradeRegion.id"
                    @close="onCloseUpgrade"
                />
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'

    export default {
        components: {},
        data () {
            return {
                upgradeRegion: null,
                fakeUpdates: false
            }
        },
        computed: {
            ...mapState('balance', ['balance']),
            ...mapState('regions', ['regions']),
            ...mapGetters('goods', ['goodById']),
            ...mapState('guide', ['step']),
            ...mapGetters('regions', ['isAllRegions']),
            list () {
                let result = [...this.regions]
                result.sort((a, b) => {
                    if (a.levelIndex === 8 && b.levelIndex !== 8) return 1
                    else if (a.levelIndex !== 8 && b.levelIndex === 8) return -1
                    else return 0
                })
                return result
            }
        },
        methods: {
            ...mapActions('control', ['pause']),

            onUpgrade (region) {
                this.$emit('open-upgrade')
                this.upgradeRegion = region
            },
            onCloseUpgrade () {
                this.upgradeRegion = null
            },
            onAdd () {
                this.pause()
                this.$router.push({name: 'game-goods'})
            }
        },
        watch: {
            step (step) {
                if (step.name === 'upgrades') {
                    this.fakeUpdates = true
                    this.upgradeRegion = this.regions[0]
                    this.$emit('open-upgrade')
                } else {
                    this.fakeUpdates = false
                    this.upgradeRegion = null
                    this.$emit('close-upgrade-silence')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .section-regions {
        position relative
        background-color #fff
        color #362AEE
        padding-top 1.7rem
        height 100%
        display flex
        flex-direction column

        +layout-sm() {
            padding-bottom 5.6rem
            &.is-all-list {
                padding-bottom 0
            }
        }

        &:after {
            position absolute
            top 0
            left 2.7rem
            right 6.2rem
            content ""
            display block
            border-bottom 1px solid #93C9FF
            +layout-sm() {
                display none
            }
        }

        &__title {
            padding-left 3rem
            color #362AEE
            font-size 1.5rem
            line-height 1.8rem
            font-weight $font-bold
            padding-bottom 1.5rem
            +layout-xs() {
                padding-left 2rem
            }
        }

        &__upgrade {
            position absolute
            top -0.1rem
            left 0
            right 0
            bottom 0
            overflow hidden
            z-index 4
            &--fake {
                opacity 0
            }
        }

        &__content {
            padding-left 2.7rem
            margin-right 2.7rem
            flex 1 1
            overflow hidden
            +layout-sm() {
                padding-left 2rem
                margin-right 2rem
            }
        }

        &__scroll {
            height 100%
            overflow hidden
            padding-right 3.3rem
            +layout-sm() {
                padding-right 2.5rem
                overflow scroll
                /*height 19.6rem*/
                height 100%
            }
            +layout-xs() {
                padding-right 2rem
            }
        }

        &__item {
            & + & {
                margin-top 1rem
            }
        }

        &__actions {
            +layout-sm() {
                position absolute
                bottom 0
                left 0
                right 0
            }

            &-btn {
                height 8rem
                width 100%
                background-color #121258
                color #C5E5FB
                font-size 2rem
                line-height 2.4rem
                font-weight $font-bold
                user-select none
                transition opacity 0.3s ease, background-color 0.3s ease

                &:hover {
                    background-color #3665F3
                }

                +layout-sm() {
                    height 5.6rem
                    font-size 1.5rem
                }

                &.disabled {
                    pointer-events none
                    opacity 0.8
                }
                &-icon {
                    display inline-flex
                    margin-right 1.9rem
                    width 2rem
                    height @width

                    +layout-sm() {
                        width 1.4rem
                        height @width
                        margin-right 1rem
                    }
                }
            }
        }
    }

    .slide-down-enter-active,
    .slide-down-leave-active {
        transition transform .6s ease
    }
    .slide-down-enter,
    .slide-down-leave-to {
        transform translate(0, 100%)
    }
</style>
